import { mapGetters } from 'vuex';
import ContentType from '@/helpers/contentType';
import TopicGroupCompletion from '@/components/content-v2/modals/topic-group-completion';
import commonMixin from '@/mixins/templates/common';
import { hasPermission } from '~/helpers/permission';

export default {
  name   : 'TopicNavigation',
  mixins : [commonMixin],
  props  : {
    nextTopic: {
      type    : Object,
      default : () => ({})
    },
    previousTopic: {
      type    : Object,
      default : () => ({})
    },
    isTheLastTopic: {
      type    : Boolean,
      default : false
    }
  },
  data() {
    return {
      isCompletionModalOpen    : false,
      wasCompletionModalOpened : false
    };
  },
  components: {
    TopicGroupCompletion
  },
  computed: {
    ...mapGetters({
      userPermissions : 'plataforma/courses/userPermissions',
      getterContent   : 'plataforma/newContent/getterContent'
    })
  },
  methods: {
    getNavigationTopicDescription(type) {
      const navigationTopic = type === 'next' ? this.nextTopic : this.previousTopic;
      if (!navigationTopic) {
        return '';
      }
      return navigationTopic.topicTypeId === ContentType.FOLDER
        ? `${navigationTopic.children.title}`
        : `${navigationTopic.title}`;
    },
    getNavigationTopicUrl(type) {
      const navigationTopic = type === 'next' ? this.nextTopic : this.previousTopic;
      if (!navigationTopic) {
        return '';
      }
      return navigationTopic.topicTypeId === ContentType.FOLDER
        ? `${navigationTopic.children.id}`
        : `${navigationTopic.id}`;
    },
    validateAndNavigateToNextTopic() {
      if (!this.isTheLastTopic) {
        return;
      }

      const hasCompletedContentMessagePermission = hasPermission(
        this.getterContent.context?.academicMainId,
        this.getterContent.context?.academicMainTypeId,
        false,
        null,
        'completed_content_message',
        this.userPermissions
      );

      if (!this.wasCompletionModalOpened && hasCompletedContentMessagePermission) {
        this.isCompletionModalOpen = true;
      } else {
        const nextTopicLink = this.getNavigationTopicUrl('next');
        this.$router.push(nextTopicLink);
        this.isCompletionModalOpen = false;
      }
      this.wasCompletionModalOpened = !this.wasCompletionModalOpened;
    }
  }
};
